function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import ButtonRedirect from './components/ButtonRedirect';
import { BUTTON_TYPES, INPUT_SIZES } from '@zillow/constellation';
export default {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;

    var _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        urlPath = _useState2[0],
        setUrlPath = _useState2[1];

    useEffect(function () {
      setUrlPath(window.location.href);
    }, []);
    var _attrs$label = attrs.label,
        label = _attrs$label === void 0 ? '' : _attrs$label,
        _attrs$redirectUrlPat = attrs.redirectUrlPath,
        redirectUrlPath = _attrs$redirectUrlPat === void 0 ? '' : _attrs$redirectUrlPat,
        _attrs$buttonType = attrs.buttonType,
        buttonType = _attrs$buttonType === void 0 ? BUTTON_TYPES.primary : _attrs$buttonType,
        _attrs$size = attrs.size,
        size = _attrs$size === void 0 ? INPUT_SIZES.sm : _attrs$size,
        _attrs$addQueryParams = attrs.addQueryParams,
        addQueryParams = _attrs$addQueryParams === void 0 ? true : _attrs$addQueryParams,
        _attrs$openInNewTab = attrs.openInNewTab,
        openInNewTab = _attrs$openInNewTab === void 0 ? false : _attrs$openInNewTab,
        _attrs$triggerSource = attrs.triggerSource,
        triggerSource = _attrs$triggerSource === void 0 ? '' : _attrs$triggerSource;
    return /*#__PURE__*/React.createElement(ButtonRedirect, {
      currentUrlPath: urlPath,
      label: label,
      redirectUrlPath: redirectUrlPath,
      buttonType: buttonType,
      size: size,
      addQueryParams: addQueryParams,
      openInNewTab: openInNewTab,
      triggerSource: triggerSource
    });
  },
  metadata: {
    schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'custom-dtc-cta/button',
    parent: ['constellation/button-group'],
    title: 'Showcase DTC Button',
    description: 'Button that redirects to Showcase DTC contact page.',
    icon: 'button',
    keywords: ['showcase', 'dtc', 'cta'],
    category: 'more',
    attributes: {
      label: {
        type: 'string',
        label: 'Label',
        default: 'Click Here',
        control: 'text'
      },
      redirectUrlPath: {
        type: 'string',
        label: 'Redirect URL Path',
        default: '',
        control: 'text'
      },
      triggerSource: {
        type: 'string',
        label: 'Trigger Source',
        default: '',
        control: 'text'
      },
      addQueryParams: {
        type: 'boolean',
        default: 'true',
        label: 'Add query params',
        control: 'boolean'
      },
      openInNewTab: {
        type: 'boolean',
        default: 'false',
        label: 'Open action link in new tab',
        control: 'boolean'
      },
      size: {
        type: 'string',
        default: INPUT_SIZES.sm,
        label: 'Button Size',
        control: 'select',
        choices: [{
          label: 'Small',
          value: INPUT_SIZES.sm
        }, {
          label: 'Medium',
          value: INPUT_SIZES.md
        }, {
          label: 'Large',
          value: INPUT_SIZES.lg
        }]
      },
      buttonType: {
        type: 'string',
        default: BUTTON_TYPES.primary,
        label: 'Button Type',
        control: 'select',
        choices: [{
          label: 'Primary',
          value: BUTTON_TYPES.primary
        }, {
          label: 'Secondary',
          value: BUTTON_TYPES.secondary
        }, {
          label: 'Caution',
          value: BUTTON_TYPES.caution
        }, {
          label: 'Tertiary',
          value: BUTTON_TYPES.tertiary
        }]
      }
    }
  }
};
//# sourceMappingURL=index.js.map